<template>
	<div>
		<v-btn
			:icon="iconButton"
			:small="iconButton || smallButton"
			:x-small="xSmallButton"
			:color="iconButton ? 'primary' : 'primary'"
			:disabled="disabled"
			:x-large="xLargeButton"
			:large="largeButton"
			@click="showDialogButtonClickEvent"
		>
			<template v-if="iconButton">
				<v-icon small>mdi-magnify</v-icon>
			</template>
			<template v-else>
				{{ buttonCaption }}
			</template>
		</v-btn>
		<choose-recycle-disposal-pattern-modal
			:enable="enableChooseDialog"
			:only-method="onlyMethod"
			:only-flow="onlyFlow"
      :own-disposer="ownDisposer"
			:final-disposal="finalDisposal"
			:required-location="requiredLocation"
			:fixed-condition.sync="fixedCondition"
			@selected="registerButtonClickEvent"
			@close="closeDialog"
		/>
	</div>
</template>

<script>
import ChooseRecycleDisposalPatternModal from "./ChooseRecycleDisposalPatternModal.vue";
import {mapActions} from "vuex";

export default {
	name: "ChooseRecycleDisposalPatternBotton",
	components: {
		ChooseRecycleDisposalPatternModal,
	},
	props: {
		buttonCaption: {
			type: String,
			default: () => "再資源化等パターンを選択",
		},
		xLargeButton: {
			type: Boolean,
			default: false,
		},
		largeButton: {
			type: Boolean,
			default: false,
		},
		smallButton: {
			type: Boolean,
			default: false,
		},
		xSmallButton: {
			type: Boolean,
			default: false,
		},
		iconButton: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		onlyMethod: {
			type: Boolean,
			default: false,
		},
		onlyFlow: {
			type: Boolean,
			default: false,
		},
		fixedCondition: {
			type: Object,
			default: null,
		},
    ownDisposer: {
      type: Boolean,
      default: false,
    },
		finalDisposal: {
			type: Boolean,
			default: null,
		},
    requiredLocation: {
      type: Boolean,
      default: false,
    },
	},
	data() {
		return {
			enableChooseDialog: false,
		};
	},
	methods: {
    ...mapActions("snackbar", {
      showError: "showError",
    }),
		showDialogButtonClickEvent() {
      if (this.requiredLocation && !this.fixedCondition.disposer_location_code) {
        this.showError({message: '処分事業場を選択してください'});
        return false;
      }

			this.enableChooseDialog = true;
		},
		registerButtonClickEvent(payload) {
			this.$emit("choseRecycleDisposalPatternCallback", payload);
			this.closeDialog();
		},
		closeDialog() {
			this.enableChooseDialog = false;
		},
	},
};
</script>
